import React, { createRef, useEffect, useMemo, useRef, useState } from 'react'
import { CheckPoint } from '../../shared/types/training.type'
import { Box, Card, FormControlLabel, Radio, RadioGroup, Stack, TextField, Typography } from '@mui/material'
import AddMinSpeed from './AddMinSpeed'
import CheckPointsGraphDisplaySettings from './CheckPointsGraphDisplaySettings'
import { Scale } from '../../pages/trainings/ExamView'
import { Layers } from '@mui/icons-material'
import { t } from 'i18next'
import { scale } from '../../enums/scale.enum'
import CheckPointsChart from './charts/CheckPointsChart'

import { CheckPointsGrid } from './charts/CheckPointsGrid'
import { CheckPointsOptionsChart } from './charts/CheckPointsOptionsChart'
import { toNumber } from 'lodash'
import { useAuth } from '../../hooks/useAuth'
import { getSpeedForChart } from '../../shared/utils/conversion'

type CheckpointsSectionProps = {
    editable?: boolean,
    checkPoints: CheckPoint[],
    time: number[]
    rawDistance: number[]
    speed: number[]
    bpm: number[],
    scaleOption: Scale,
    onChangeScale: (value: Scale) => void,
    isFinishlineActive: boolean,
    flIndex?: number | null,
    restrictedMode?: boolean,
    labelsColor?: string,
    adaptiveDisplay?: boolean,
}
function CheckpointsSection({ labelsColor = '#fff', adaptiveDisplay = false, restrictedMode, editable, checkPoints, time, speed, bpm, rawDistance, onChangeScale, isFinishlineActive, flIndex }: CheckpointsSectionProps) {
    const [speedCondition, setSpeedCondition] = useState<number | undefined>(0)
    const ref = useRef<any>(null)
    const chartRef = useRef<any>(null)
    const { getSpeedUnit } = useAuth()
    const [scaleOption, setScaleOption] = useState<Scale>('DISTANCE')

    const [conditionCheckpoints, setConditionCheckpoints] = useState<CheckPoint[]>([])

    useEffect(() => {

        if (!checkPoints) return
        let filteredCheckpoints = checkPoints.filter(e => toNumber(getSpeedForChart(e.speed, getSpeedUnit()?.value ?? "") ?? 0) > (speedCondition ?? 0))

        setConditionCheckpoints(filteredCheckpoints)

    }, [speedCondition, checkPoints])


    return (
        <Stack id='cp-section' direction={'column'} spacing={2}>


            {
                !restrictedMode && <>
                    {/* Scale Section */}
                    <Box display={'flex'} justifyContent={'end'} flexWrap={'wrap'} gap={1}>
                        {editable && <CheckPointsGraphDisplaySettings></CheckPointsGraphDisplaySettings>}
                        <Card sx={{ display: 'flex', flexDirection: 'column', borderRadius: 3, p: 1 }} >
                            <Typography variant='caption' color={'GrayText'} display={'flex'} alignItems={'center'} gap={'3px'}>
                                <Layers sx={{ width: 14, height: 14 }}></Layers>
                                {t('graph:scale')} </Typography>
                            <RadioGroup

                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            >
                                {scale.map(s => (
                                    <FormControlLabel key={s.value} value={s.value} checked={scaleOption === s.value} control={<Radio onChange={e => {

                                        setScaleOption(e.target.value as Scale)
                                    }} size='small' />} label={<Typography variant='caption' fontWeight={500}>{t(s.key)}</Typography>} />

                                ))}

                            </RadioGroup>
                        </Card>
                    </Box>



                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <AddMinSpeed editable={editable} speed={speedCondition} onChangeSpeed={value => setSpeedCondition(value)}></AddMinSpeed>
                    </Box>
                </>
            }

            <Box
                sx={{
                    backgroundColor: adaptiveDisplay ? 'white' : 'transparent',
                    padding: 2,
                    borderRadius: 1,
                }}

            >
                <CheckPointsChart labelsColor={labelsColor} checkpoints={conditionCheckpoints} distance={rawDistance} time={time} speed={speed} bpm={bpm} scaleOption={scaleOption} isFinishLineActive={isFinishlineActive} flIndex={flIndex}></CheckPointsChart>
                <CheckPointsOptionsChart labelsColor={labelsColor} ref={chartRef} onHover={(cpId) => { ref.current?.highlightRow(cpId) }} defaultScale={scaleOption} checkPoints={conditionCheckpoints} time={time} distance={rawDistance}></CheckPointsOptionsChart>
            </Box>
            <CheckPointsGrid onRowHover={(cpId) => { chartRef.current?.highlightPoint(cpId) }} ref={ref} CheckPoints={conditionCheckpoints}></CheckPointsGrid>
        </Stack>
    )
}

export default CheckpointsSection